import { render } from "./StoreOnboardingStepBilling.vue?vue&type=template&id=f54e60c8"
import script from "./StoreOnboardingStepBilling.vue?vue&type=script&lang=js"
export * from "./StoreOnboardingStepBilling.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__